import styled from 'styled-components'
import { Link as LinkR } from 'react-router-dom'
import { Link as LinkS } from 'react-scroll'

export const Nav = styled.nav`
    //background: #000;
    background: ${({ $scrollNav, theme }) => ($scrollNav ? theme.colors.black : 'transparent')};
    height: 80px;
    margin-top: -80px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem; 
    position: sticky;
    top: 0;
    z-index: 10;
    transition: all 0.3s ease-in-out;

    @media screen and (max-width: 960px) {
        transition: 0.8s all ease;
    }
`
export const NavbarContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 80px;
    z-index: 1;
    width: 100%;
    padding: 0 24px;
    max-width: 1100px;

    @media screen and (max-width: 768px) {
        padding: 0 16px;
    }
`
export const NavLogo = styled(LinkR)`
    //color: #B05FFD;
    color: ${({ theme }) => theme.colors.white};
    justify-self: flex-start;
    cursor: pointer;
    font-size: 1.5rem;
    display: flex;
    align-items: center;
    margin-left: 24px;
    font-weight: bold;
    text-decoration: none;
    transition: all ease 0.2s;
    height: 100%;

    &:hover {
        color: ${({ theme }) => theme.colors.primary};
    }

    @media screen and (max-width: 768px) {
        margin-left: 0;
        height: auto;
    }
`

export const MobileIcon = styled.div`
    display: none;

    @media screen and (max-width: 768px) {
        display: flex;
        align-items: center;
        font-size: 1.8rem;
        cursor: pointer;
        color: ${({ theme }) => theme.colors.white};
    }
`

export const NavMenu = styled.ul`
    display: flex;
    align-items: center;
    list-style: none;
    text-align: center;
    margin-right: -22px;
    height: 80px;

    @media screen and (max-width: 768px) {
        display: none;
    }

`

export const NavItem = styled.li`
    height: 80px;
`

export const NavLinks = styled(LinkS)`
    color: ${({ theme }) => theme.colors.white};
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 0 1rem;
    height: 100%;
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    &.active {
        border-bottom: 3px solid ${({ theme }) => theme.colors.primary};
    }

    &:hover {
        color: ${({ theme }) => theme.colors.primary};
    }

`
export const NavBtn = styled.nav`
    display: flex;
    align-items: center;
    @media screen and (max-width: 768px) {
        display: none;
    }

`

export const NavBtnLink = styled.button`
    border-radius: 50px;
    background: ${({ theme }) => theme.colors.primary};
    white-space: nowrap;
    padding: 10px 22px;
    color: ${({ theme }) => theme.colors.white};
    font-size: 1rem;
    outline: none;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    font-weight: 900;

    &:hover {
        transition: all 0.2s ease-in-out;
        background: ${({ theme }) => theme.colors.white};
        color: ${({ theme }) => theme.colors.primary};
    }
`

export const NavLogoImg = styled.img`
    height: 75px;
    width: 75px;
    margin-right: 12px;
    border-radius: 50%;
    object-fit: contain;
    filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0.8)) drop-shadow(0 0 20px rgba(255, 255, 255, 0.5));
    flex-shrink: 0;

    @media screen and (max-width: 768px) {
        height: 60px;
        width: 60px;
        margin-right: 8px;
    }
`